import { useEffect } from 'react';

const RICKROLL_URL = 'https://www.youtube.com/watch?v=a-Bd5PjpeDc&t=62s';

const Rickroll = () => {
  useEffect(() => {
    window.location.replace(RICKROLL_URL);
  }, []);

  return null;
};

export default Rickroll;
